import type { FieldType, FormElement } from "./types"

export const formElements = new Map<FieldType, FormElement>([
    [
        "text",
        { type: "text", label: "components:form_builder.type.text", icon: "fa-font", hasPlaceholder: true },
    ],
    [
        "email",
        { type: "email", label: "components:form_builder.type.email", icon: "fa-envelope", hasPlaceholder: true },
    ],
    [
        "number",
        { type: "number", label: "components:form_builder.type.number", icon: "fa-hashtag", hasPlaceholder: true },
    ],
    [
        "textarea",
        { type: "textarea", label: "components:form_builder.type.textarea", icon: "fa-align-left", hasPlaceholder: true },
    ],
    [
        "select",
        { type: "select", label: "components:form_builder.type.select", icon: "fa-list", hasOptions: true },
    ],
    [
        "checkbox",
        { type: "checkbox", label: "components:form_builder.type.checkbox", icon: "fa-check-square", hasOptions: true },
    ],
    [
        "radio",
        { type: "radio", label: "components:form_builder.type.radio", icon: "fa-dot-circle", hasOptions: true },
    ],
    [
        "date",
        { type: "date", label: "components:form_builder.type.date", icon: "fa-calendar", hasPlaceholder: true },
    ],
    [
        "password",
        { type: "password", label: "components:form_builder.type.password", icon: "fa-lock", hasPlaceholder: true },
    ],
    [
        "submit",
        { type: "submit", label: "components:form_builder.type.submit", icon: "fa-paper-plane", isSubmit: true },
    ],
    [
        "layout",
        { type: "layout", label: "components:form_builder.type.layout", icon: "fa-columns", isLayout: true },
    ],
    [
        "upload",
        { type: "upload", label: "components:form_builder.type.upload", icon: "fa-upload", hasFileConfig: true },
    ],
    [
        "topic",
        { type: "topic", label: "components:form_builder.type.topic", icon: "fa-comments" },
    ],
])
